namespace Solovis.Reports.Parameters {

    interface Investment {
        label: string;
        investmentId: number;
        resourceId: number;
    }
    interface Entity {
        label: string;
        entityId: number;
        resourceId: number;
    }

    export class EntityOrInvestmentParameterControl extends Solovis.UI.BaseControl {

        public initialParameterValue;
        public currentEntityOrInvestment;

        public selectedEntityOrInvestmentLabel;
        public selectEntityOrInvestmentLink;
        public _selectionDialog: Solovis.UI.Dialog;

        private _portalServices: Solovis.Portal.IPortalServices;

        static hasNewRender = true;
        private _selectRef;

        constructor(options) {
            super(options);

            this._portalServices = options.portalServices;

            this.initialParameterValue = (typeof options.initialValue != "undefined") ? options.initialValue : null;
            this.currentEntityOrInvestment = this.initialParameterValue;
        }


        public static preload(newValue, callback, portalServices: Solovis.Portal.IPortalServices) {
            if (!portalServices) {
                portalServices = new Solovis.Portal.SitePortalServices();
            }

            if (newValue && (newValue.entityId || newValue.investmentId || newValue.resourceId)) {
                var loadOptions: any = { entityOrInvestment: {} };
                if (newValue.entityId)
                    loadOptions.entityOrInvestment.entityId = newValue.entityId;
                if (newValue.investmentId)
                    loadOptions.entityOrInvestment.investmentId = newValue.investmentId;
                if (newValue.resourceId)
                    loadOptions.entityOrInvestment.resourceId = newValue.resourceId;

                portalServices.reportDataLoader().loadDataSetAsync("/Solovis/Metadata/ParameterLoad",
                    loadOptions,
                    function (response, success) {
                        if (success) {
                            var dataSet = response.result.dataSet;
                            var entityOrInvestmentData = dataSet.entityOrInvestment ? dataSet.entityOrInvestment : null;
                            callback(entityOrInvestmentData, true);
                        }
                        else {
                            callback(null, false);
                        }
                    });
            }
            else {
                callback(null, true);
            }
        }

        public static shouldPreload(value) {
            if (!value || (value.resourceId && value.label)) {
                // Already loaded.
                return false;
            }

            return true;
        }

        public static serializeParameterValue(value): any {
            if (value) {
                if (value.entityId) {
                    return { entityId: value.entityId };
                }
                else if (value.investmentId) {
                    return { investmentId: value.investmentId };
                }
                else if (value.resourceId) {
                    return { resourceId: value.resourceId };
                }
            }

            return null;
        }

        public doRender() {
            if (this.options.renderMode === 'modern') {
                this.doRenderNew();
            } else {
                this.doRenderClassic();
            }
        }

        private async doRenderNew() {
            var self = this;
            const target = this.container[0];

            const { fetchEntitiesOrInvestments } = await (window as any).importShim('@solovis/pa-utils');
            const { getIconForEntityType } = await (window as any).importShim('@solovis/pa-ui-components');
            await Solovis.UX.Utils.placeComponent(
                "AsyncSelect",
                target,
                {
                    cacheOptions: true,
                    defaultValue: (self.options as any).initialValue || undefined,
                    getOptionIcon: getIconForEntityType,
                    getOptionLabel: (option: Entity | Investment) => option.label,
                    getOptionValue: (option) => {
                        if (option.entityId) {
                            return "Entity" + option.entityId;
                        } else {
                            return "Investment" + option.investmentId;
                        }
                    },
                    loadOn: "input",
                    loadOptions: (search: string) => new Promise(async (resolve, reject) => {
                        try {
                            const options = await fetchEntitiesOrInvestments({ filterText: search, maxItems: 10 });
                            if (options.hasMoreData) {
                                options.data.push({
                                    label: "More Results",
                                    entityId: -1,
                                    resourceId: -1,
                                    originalQuery: { filterText: search, excludeDemotedItems: true },
                                })
                            }
                            resolve(options.data);
                        } catch (e) {
                            reject(e);
                        }
                    }),
                    onChange: (selectedItem) => {
                        //if nothing selected don't notify
                        if (!selectedItem) {
                            return;
                        }
                        if (selectedItem.label === "More Results") {
                            Solovis.Reports.Parameters.EntityOrInvestmentExtendedSearchResultsDialog.showDialog({
                                query: selectedItem.originalQuery,
                                handleSelection: (selectedItem) => {
                                    self._selectRef.setValue(selectedItem);
                                },
                                handleClose: () => {
                                    //on close remove the more results options if nothing selected
                                    if (self._selectRef.getValue()[0].label === "More Results") {
                                        self._selectRef.clearValue();
                                    }
                                }
                            });
                            return;
                        }
                        self.currentEntityOrInvestment = selectedItem;
                        self.notifyParameterValueChanged();
                    },
                    ref: (ref) => {
                        self._selectRef = ref;
                    }
                }
            );
        }


        public doRenderClassic() {
            var self = this;

            this.selectedEntityOrInvestmentLabel = $("<a>").appendTo(this.container);

            Solovis.UI.PopupLinkPanel.onElementClick(this.selectedEntityOrInvestmentLabel, function (e) {
                if (self.currentEntityOrInvestment) {
                    if (self.currentEntityOrInvestment.entityId) {
                        Solovis.UI.PopupLinkPanel.showLinks({
                            offset: { left: e.pageX, top: e.pageY },
                            links: self._portalServices.reportLinker().getEntityLinks(self.currentEntityOrInvestment.entityId)
                        });
                    }
                    else if (self.currentEntityOrInvestment.investmentId) {
                        Solovis.UI.PopupLinkPanel.showLinks({
                            offset: { left: e.pageX, top: e.pageY },
                            links: self._portalServices.reportLinker().getInvestmentLinks(self.currentEntityOrInvestment.investmentId)
                        });
                    }
                }
            });

            this.selectEntityOrInvestmentLink = $("<a>").html("<span class='fa fa-pencil'></span>").appendTo(this.container);

            this.selectEntityOrInvestmentLink.click(function () {
                self._toggleSelectorDialog(function (entityOrInvestment) {
                    self._setCurrentEntityOrInvestmentData(entityOrInvestment);
                    self.notifyParameterValueChanged();
                });
            });

            // Set initial parameter value text.
            if (this.currentEntityOrInvestment) {
                this._setCurrentEntityOrInvestmentData(this.currentEntityOrInvestment);
            }

            // Setup drop handler for Solovis reference.
            Solovis.Site.DragDropManager.setupSolovisRefDrop(this.container, function (solovisRef) {
                if (!solovisRef.type || solovisRef.type == "entity" || solovisRef.type == "investment" || solovisRef.type == "entityOrInvestment") {
                    self.setParameterValue(solovisRef.value);
                }
            });
        }

        public _setCurrentEntityOrInvestmentData(entityData) {
            this.currentEntityOrInvestment = entityData;
            if (this.currentEntityOrInvestment) {
                this.selectedEntityOrInvestmentLabel.text(this.currentEntityOrInvestment.label + " ");
            }
            else {
                this.selectedEntityOrInvestmentLabel.text("");
            }
        }


        public setParameterValue(newValue, more?) {
            Solovis.Reports.Parameters.ParameterControlHelper.handleSetParameterValue(
                this, EntityOrInvestmentParameterControl, this._setCurrentEntityOrInvestmentData, newValue, more);
        }

        public getParameterValue() {
            if (this.currentEntityOrInvestment) {
                return Solovis.deepCopy(this.currentEntityOrInvestment);
            }
            else {
                return null;
            }
        }

        public notifyParameterValueChanged() {
            $(this).trigger("parameterValueChanged");
        }

        public _toggleSelectorDialog(selectionCallback) {
            var self = this;

            if (this._selectionDialog) {
                // We already have the selection dialog open, so close it.
                this._selectionDialog.close();
                this._selectionDialog = null;
                return;
            }

            var selectorControlHostDiv = $("<div>");
            var selectorControlHost = new Solovis.UI.ControlHost({ container: selectorControlHostDiv });

            var currentInvestment = null;

            if (this.currentEntityOrInvestment && this.currentEntityOrInvestment.investmentId) {
                currentInvestment = this.currentEntityOrInvestment;
            }

            var selectorControl = new (Solovis.InvDataSelectors as any).EntityOrInvestmentSelectorControl({
                controlHost: selectorControlHostDiv,
                initialValue: currentInvestment,
                portalServices: this._portalServices,

                selectionCallback: function (entityOrInvestment) {
                    selectionCallback(entityOrInvestment);
                    self._selectionDialog.close();
                },
                cancelCallback: function () {
                    self._selectionDialog.close();
                }
            });

            var minWidth = 195;
            var minHeight = 170;

            var getDesiredWidth = function () {
                var desiredWidth = Math.min($(window).width(), 450);
                return desiredWidth;
            };

            var getDesiredHeight = function () {
                var currentViewInfo = selectorControl.getCurrentViewInfo();
                if (currentViewInfo.isEntity) {
                    return 135;
                }
                else if (currentViewInfo.isInvestment) {
                    if (currentViewInfo.investmentSelector) {
                        switch (currentViewInfo.investmentSelector.activeTabCode) {
                            case "byName": return 170;

                            case "byOwner":
                            case "byHolding": {
                                return Math.min($(window).height(), 320);
                            }
                        }
                    }
                }

                return minHeight;
            };


            $(selectorControl).bind("currentViewInfoChanged", function () {
                if (self._selectionDialog) {
                    var desiredWidth = getDesiredWidth();
                    var desiredHeight = getDesiredHeight();
                  
                    if (Solovis.UX.Utils.isNewUxEnabled()) {
                        // For handling the extra padding around buttons in the new experience
                        desiredHeight += 24;
                    }

                    self._selectionDialog.width(desiredWidth);
                    self._selectionDialog.height(desiredHeight);
                    self._selectionDialog.autoAdjustToViewport();

                    var dialogContentHeight = self._selectionDialog.getAvailableContentHeight();

                    selectorControl.setAvailableHeight(dialogContentHeight);
                }
            });

            selectorControlHost.setCurrentControl(selectorControl);

            // Determine dialog position.        
            var linkOffset = $(this.selectedEntityOrInvestmentLabel).offset();
            var linkHeight = $(this.selectEntityOrInvestmentLink).outerHeight();
            var dialogPosition = {
                left: linkOffset.left,
                top: linkOffset.top + linkHeight + 5
            };

            var adjustedPosition = Solovis.UI.Dialog.autoAdjustSizeAndPosToViewport(dialogPosition, { width: 350, height: 150 });


            this._selectionDialog = new Solovis.UI.Dialog({
                container: selectorControlHostDiv,
                ownerDialog: Solovis.UI.Dialog.findContainingDialog(this.container),

                title: false,
                autoOpen: true,
                destroyOnClose: true,
                actions: ["Close"],
                noAnimation: true,
                position: adjustedPosition,
                minWidth: minWidth,
                width: minWidth,

                buttons: [
                    {
                        label: "Clear",
                        click: function () {
                            selectionCallback(null);
                            self._selectionDialog.close();
                        }
                    },
                    {
                        label: "Cancel",
                        click: function () {
                            self._selectionDialog.close();
                        }
                    }
                ],

                resize: function () {
                    var overallHeight = this.getAvailableContentHeight();

                    selectorControl.setAvailableHeight(overallHeight);
                },

                deactivate: function () {
                    self._selectionDialog = null;
                }
            });
        }
    }

}
